<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M11.2455 13.2444C10.3028 13.8291 9.19079 14.1667 7.99992 14.1667C4.59416 14.1667 1.83325 11.4058 1.83325 8C1.83325 4.59424 4.59416 1.83333 7.99992 1.83333C11.4057 1.83333 14.1666 4.59424 14.1666 8C14.1666 9.31979 13.5107 10.6828 11.9809 10.5437C10.7224 10.4293 9.81651 9.28384 9.99523 8.03283L10.3483 5.60185M9.95825 8.32031C9.75328 9.77874 8.55262 10.8156 7.2765 10.6363C6.00037 10.4569 5.13203 9.12926 5.337 7.67084C5.54197 6.21241 6.74263 5.17551 8.01875 5.35486C9.29488 5.53421 10.1632 6.86189 9.95825 8.32031Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="square"
  />
</svg>
